import store from '@/store'

export default [
  {
    path: '/pickup-card-creations',
    name: 'pickup-card-creation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pickup-card-creation/index.vue')
  },
  {
    path: '/pickup-card-creations/create',
    name: 'pickup-card-creation-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pickup-card-creation/create.vue')
  },
  {
    path: '/pickup-card-creations/:id',
    name: 'pickup-card-creation-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pickup-card-creation/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('pickupCardCreation/find', to.params.id)
      next()
    }
  },
  {
    path: '/pickup-card-creations/card/by-classes',
    name: 'pickup-card-creation-card-by-class',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pickup-card-creation/card-by-class.vue')
  }
]
